import React from 'react';

import CardStyle from './card';
import DropdownStyle from './dropdown';
import TableStyle from './table';

// Ant Design component style overrides specific to the experience app.
const Overrides = () => (
  <>
    <TableStyle />
    <CardStyle />
    <DropdownStyle />
  </>
);

export default Overrides;
